module.exports = __webpack_public_path__ + "static/media/RMC-cta-002.df6d9099.jpg";